import {
  createRequestTypes,
  createAction,
  postfixes,
} from '../../store/actions'

export const service = 'AUTH'
export const CURRENT_USER_UPSERT = createRequestTypes(
  'CURRENT_USER_UPSERT',
  service,
)
export const currentUserUpsert = {
  request: payload =>
    createAction(CURRENT_USER_UPSERT[postfixes.REQUEST], payload),
}

export const USER_REMOVE = createRequestTypes('USER_REMOVE', service)
export const UserRemove = {
  request: payload => createAction(USER_REMOVE[postfixes.REQUEST], payload),
}
